import { CtaBlock } from '@design-system/cta-block';
import { FluidGrid } from '@design-system/fluid-grid';
import { PageBlock } from '@design-system/page-block';
import { Typography } from '@design-system/typography';
import React, { forwardRef } from 'react';

import { ContactUsBlockProps } from './models';

const ContactUsBlock = forwardRef<HTMLDivElement, ContactUsBlockProps>(
  ({ pageBlock, fluidGrid, links, showMore, id, uid }, ref) => (
    <PageBlock
      ref={ref}
      {...pageBlock}
      className="contact-us"
      id={id}
      componentUid={uid}
    >
      <FluidGrid {...fluidGrid}>
        {links.map(({ title, href, header, ariaLabel }) => (
          <div key={header}>
            <Typography
              content={header}
              tag="h3"
              variant="headline"
              weight="bold"
              size="xs"
              align="start"
              className="contact-us__headline"
            />

            <Typography
              className="contact-us__link"
              variant="headline"
              size="xs"
              content={title}
              link={
                href
                  ? {
                      props: {
                        href,
                        variant: 'heading-link',
                        'aria-label': ariaLabel,
                      },
                    }
                  : undefined
              }
            />
          </div>
        ))}
      </FluidGrid>
      {showMore ? <CtaBlock align="center" {...showMore} /> : null}
    </PageBlock>
  )
);

export default ContactUsBlock;
